import React, { useCallback, useEffect } from 'react'
import RecordSearch from './RecordSearch'
import RecordSelectContent from './RecordSelectContent'
import RecordRow from './RecordRow'
import Pagination from '../Pagination'
import { useRecoilState, useRecoilValue} from 'recoil'
import { authenticated } from '../../recoil/auth'
import { recordLoading, recordData, recordSearch, recordCurrentPage } from '../../recoil/record'
import axios from 'axios'
import { domainWeb } from '../../config/constants'
import { contentSelected } from '../../recoil/content'
import WaitingText from '../WaitingText'

const RecordTable = () => {
	const [loading, setLoading] = useRecoilState(recordLoading);
	const [records, setRecords] = useRecoilState(recordData);
	const auth = useRecoilValue(authenticated);
	const search = useRecoilValue(recordSearch);
	const selected = useRecoilValue(contentSelected);
	const [currentPage, setCurrentPage] = useRecoilState(recordCurrentPage);
	
	const getRecordsData = useCallback( async () => {
		setLoading(true);
		try {
			let url = `${domainWeb}/records?search=${search}&content_id=${selected}&page=${currentPage}`;
			let response = await axios.get(url,
				{headers: {
						'Content-Type': 'application/json', 
						'Accept': 'application/json', 
						'Authorization': 'Bearer ' + auth.token,
				}},
			);
			setRecords(response.data);
			setLoading(false);
		} catch (error) {
			console.error(error);
			setLoading(false);
		}
	}, [setLoading, auth.token, setRecords, search, selected, currentPage])

	const loadData = () => {
		if (loading || records.data === undefined) {
			return <div className="p-3"><WaitingText /></div>
		}
		if (records.data.length === 0) {
			return <div className="p-3">Tidak ada data.</div>
		}
		return (
			<div>
				{
					records.data.map((item, i) => <RecordRow key={i} data={item}/>)
				}
			</div>
		);
	}

	const changePage = (page) => {
		setCurrentPage(page);
	}

	useEffect(() => {
		getRecordsData();
	}, [getRecordsData]);
	
	return (
    <div className="bg-white rounded-lg shadow">
        <div className="flex items-center justify-between px-8 py-5">
            <h3 className="text-xl font-semibold">Hasil Kuis Konten</h3>
            <div className="flex w-1/2 gap-3">
                <RecordSearch />
                <RecordSelectContent />
            </div>
        </div>
        <div className="flex items-center gap-5 px-8 py-3">
            <div className="w-1/5">Tanggal</div>
            <div className="w-1/3">Konten</div>
            <div className="w-1/3">Pengguna</div>
            <div>Nilai</div>
        </div>
        <div className="w-full border"></div>
        <div className="px-5 py-3">
					{ loadData() }
        </div>
        <div className="w-full border"></div>
        <div className="flex justify-end gap-5 px-8 py-3">
            <Pagination currentPage={records.page} maxPage={records.max_page} changePage={changePage}/>
        </div>
    </div>
  )
}

export default RecordTable